"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var spacing = {
    "space96": "6rem",
    "space64": "4rem",
    "space48": "3rem",
    "space40": "2.5rem",
    "space32": "2rem",
    "space28": "1.75rem",
    "space24": "1.5rem",
    "space20": "1.25rem",
    "space16": "1rem",
    "space12": "0.75rem",
    "space8": "0.5rem",
    "space4": "0.25rem",
    "space2": "0.125rem"
};
exports.default = spacing;
//# sourceMappingURL=spacing.js.map